import { FC } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { Button, ButtonGroup } from 'reactstrap';
import SvgRender from '../general/SvgRender';
import Tooltip from '@/library/components/general/Tooltip';

type SizeType = 'sm' | 'md' | 'lg';

type TabType = {
  label?: string;
  icon?: string;
  tooltip?: string;
  warning?: string;
  className?: string;
  iconStyle?: Record<string, unknown>;
  onClick?: () => void;
} & (
  | {
      to: NavLinkProps['to'];
      isActive?: (match: Record<string, unknown> | null, location: Location) => boolean; //  NavLinkProps['isActive']
    }
  | { to?: undefined; isActive?: boolean }
);

const Tab: FC<TabType & { size: SizeType; index: number }> = ({
  label,
  icon,
  tooltip,
  warning,
  to,
  isActive,
  className = '',
  size = 'lg',
  iconStyle,
  index,
  ...rest
}) => {
  const Tag = to ? NavLink : Button;

  const props = to
    ? {
        className: `btn-group-button btn-${size} ${className}`,
        exact: true,
        to,
        isActive: isActive as any // Temporary fix, due to react-router version mismatch
      }
    : {
        color: 'group-button',
        size,
        to: to ?? '',
        className: `${isActive ? 'active' : ''} ${className}`
      };

  return (
    <>
      <Tag id={`nav-tab-${index}`} {...props} {...rest}>
        {icon ? <SvgRender src={icon} style={iconStyle || { width: 16, height: 16 }} /> : label}
      </Tag>

      {!!tooltip && (
        <Tooltip fade={false} target={`nav-tab-${index}`} placement="bottom">
          {tooltip}
        </Tooltip>
      )}

      {!!warning && (
        <>
          <div
            id={`nav-tab-${index}`}
            className="btn-group-button--warning position-absolute bg-red"
          />
          <Tooltip placement="right" innerClassName="min-w-fit" target={`nav-tab-${index}`}>
            {warning}
          </Tooltip>
        </>
      )}
    </>
  );
};

export type NavigationGroupTabsProps = {
  tabs: TabType[];
  className?: string;
  size?: SizeType;
};

const NavigationGroupTabs: FC<NavigationGroupTabsProps> = ({
  tabs = [],
  className = '',
  size = 'lg'
}) => {
  return (
    <ButtonGroup className={`d-inline-flex g-0 group-button ${className}`}>
      {tabs.map((tab, i) => (
        <Tab size={size} key={i} index={i} {...tab} />
      ))}
    </ButtonGroup>
  );
};

export default NavigationGroupTabs;
